import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Card from "components/Card/Card.js";
import wizardStyle from "assets/jss/material-dashboard-pro-react/components/wizardStyle.js";

class TabNavigator extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: this.calculateTabWidth(),
    };
    this.wizardRef = React.createRef(); // Referencia para enfocar el wizard
    this.updateWidth = this.updateWidth.bind(this);
  }

  componentDidMount() {
    window.addEventListener("resize", this.updateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWidth);
  }

  updateWidth() {
    this.setState({ width: this.calculateTabWidth() });
  }

  calculateTabWidth() {
    const stepsCount = this.props.steps.length;
    if (stepsCount === 1) return "100%";
    if (window.innerWidth < 600) return stepsCount === 3 ? "33.33%" : "50%";
    return stepsCount === 2 ? "50%" : `${100 / stepsCount}%`;
  }

  handleTabChange(index) {
    if (this.props.setActiveStep) {
      this.props.setActiveStep(index);
    }
  }

  focusWizard = () => {
    if (this.wizardRef.current) {
      this.wizardRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
      this.wizardRef.current.focus(); // Intenta enfocar
    }
  };

  render() {
    const { classes, steps, activeStep } = this.props;
    const { width } = this.state;

    return (
      <div
        className={classes.wizardContainer}
        ref={this.wizardRef}
        tabIndex="-1" // Permite que sea enfocable
      >
        <Card className={classes.card}>
          <div className={classes.wizardNavigation}>
            <ul className={classes.nav}>
              {steps.map((step, index) => (
                <li
                  key={index}
                  className={cx(classes.steps, {
                    [classes[step.color]]: activeStep === index,
                  })}
                  style={{ width }}
                >
                  <a
                    href="#"
                    className={cx(classes.stepsAnchor, {
                      [classes.active]: activeStep === index,
                    })}
                    onClick={(e) => {
                      e.preventDefault();
                      this.handleTabChange(index);
                    }}
                  >
                    {step.stepName}
                  </a>
                </li>
              ))}
            </ul>
            <div
              className={cx(classes.movingTab, classes[steps[activeStep].color])}
              style={{
                width,
                transform: `translateX(${activeStep * 100}%)`,
                transition: "all 0.5s ease",
              }}
            >
              {steps[activeStep].stepName}
            </div>
          </div>

          <div className={classes.content}>
            {steps.map((step, index) => (
              <div
                key={index}
                className={cx({
                  [classes.stepContentActive]: activeStep === index,
                  [classes.stepContent]: activeStep !== index,
                })}
              >
                {step.stepComponent}
              </div>
            ))}
          </div>
        </Card>
      </div>
    );
  }
}

TabNavigator.propTypes = {
  classes: PropTypes.object.isRequired,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      stepName: PropTypes.string.isRequired,
      stepComponent: PropTypes.node.isRequired,
      color: PropTypes.oneOf([
        "primary",
        "warning",
        "danger",
        "success",
        "info",
        "rose",
      ]).isRequired,
    })
  ).isRequired,
  activeStep: PropTypes.number.isRequired,
  setActiveStep: PropTypes.func.isRequired,
};

export default withStyles(wizardStyle)(TabNavigator);
